'use client'
import { jsx } from 'react/jsx-runtime';
import { createContext, useContext, useRef } from 'react';

const popperContext = createContext(undefined);
const PopperProvider = ({ children, className, style, }) => {
    const { Provider } = popperContext;
    const containerRef = useRef(null);
    return (jsx(Provider, { value: {
            containerRef,
        }, children: jsx("div", { ref: containerRef, style: Object.assign({ position: 'relative' }, style), className: className, children: children }) }));
};
const usePopper = () => {
    const context = useContext(popperContext);
    if (!context) {
        throw new Error('To use popper, use the PopperProvider above in the dom hierarchy');
    }
    return context;
};

export { PopperProvider, popperContext, usePopper };
